module.exports = __webpack_public_path__ + "img/Airbnb-Working-From-Office-Everyday-stretches.97dfa266.jpg";